import React from "react";
import { Controller } from "react-hook-form";
import {
  effectivenessList,
  informationCollectionToolList,
  oftenCollectedList,
} from "../../../utils/types";
import { formatOptions } from "../../../utils/helpers";
import Select from "react-select";

interface DataCollectionEditProps {
  control: any;
  errors: any;
  watch: any;
  setValue: any;
}

const DataCollectionEdit: React.FC<DataCollectionEditProps> = ({
  control,
  errors,
  watch,
  setValue,
}) => {
  const frequency = formatOptions(oftenCollectedList);
  const techOptions = formatOptions(informationCollectionToolList);
  const effectivenessOptions = formatOptions(effectivenessList);

  return (
    <div className="font-Inter max-w-2xl">
      <div className="space-y-6">
        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">
            Name of the tool used to collect data{" "}
            <span className="text-red-500">*</span>
          </label>
          <Controller
            name="toolUsedToCollectData"
            control={control}
            render={({ field }) => (
              <input
                type="text"
                {...field}
                className={`w-full px-3 py-2 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                  errors.toolUsedToCollectData
                    ? "border-red-500"
                    : "border-gray-300"
                }`}
                placeholder="E.g. mobile meter reading app"
              />
            )}
          />
          {errors.toolUsedToCollectData && (
            <p className="text-red-500 text-xs mt-1">
              {errors.toolUsedToCollectData.message}
            </p>
          )}
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">
            What technology is used to collect the information{" "}
            <span className="text-red-500">*</span>
          </label>
          <Controller
            name="informationCollectionTool"
            control={control}
            render={({ field }) => (
              <Select
                options={techOptions}
                placeholder="Select Technology..."
                onChange={(selected) => field.onChange(selected?.value || "")}
                value={
                  techOptions.find((opt) => opt.value === field.value) || null
                }
              />
            )}
          />
          {errors.informationCollectionTool && (
            <p className="text-red-500 text-xs mt-1">
              {errors.informationCollectionTool.message}
            </p>
          )}
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">
            How often is data collected <span className="text-red-500">*</span>
          </label>
          <Controller
            name="oftenCollected"
            control={control}
            render={({ field }) => (
              <Select
                options={frequency}
                placeholder="Select Frequency..."
                onChange={(selected) => field.onChange(selected?.value || "")}
                value={
                  frequency.find((opt) => opt.value === field.value) || null
                }
              />
            )}
          />
          {errors.oftenCollected && (
            <p className="text-red-500 text-xs mt-1">
              {errors.oftenCollected.message}
            </p>
          )}
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-medium text-gray-700">
            How well does the data collection tool serve its purpose?{" "}
            <span className="text-red-500">*</span>
          </label>
          <Controller
            name="dataCollectionToolPurposeServe"
            control={control}
            render={({ field }) => (
              <Select
                options={effectivenessOptions}
                placeholder="Select Effectiveness..."
                onChange={(selected) => field.onChange(selected?.value || "")}
                value={
                  effectivenessOptions.find(
                    (opt) => opt.value === field.value
                  ) || null
                }
              />
            )}
          />
          {errors.dataCollectionToolPurposeServe && (
            <p className="text-red-500 text-xs mt-1">
              {errors.dataCollectionToolPurposeServe.message}
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default DataCollectionEdit;
